const wdgtPOI = document.querySelectorAll('.wdgt-Poi');

window.fireOnVisible(wdgtPOI, async() => {
    await import('./assets/css/poi.scss');
});

const wdgtPOITextbox = document.querySelectorAll('.wdgt-Poi .textboxes');

window.fireOnVisible(wdgtPOITextbox, async() => {
    await import('./assets/css/poiTextbox.scss');
});

const wdgtPOIList = document.querySelectorAll('.wdgt-Poi .listMap');

window.fireOnVisible(wdgtPOIList, async() => {
    await import('./assets/css/poiList.scss');
});

let wdgtPOIMap = document.querySelectorAll('.wdgt-Poi .textboxMap.textboxes');

if (wdgtPOIMap.length === 0) {
    wdgtPOIMap = wdgtPOIList.length > 0 ? wdgtPOIList : document.querySelectorAll('.wdgt-Poi .mapOnly');
}

window.fireOnVisible(wdgtPOIMap, async(poiMapElem) => {
    await import('./assets/css/poiMap.scss');
    await import('./assets/js/PoiMap.ts').then((PoiMap) => {
        const poiMap = new PoiMap.default(poiMapElem, {
            scrollToTextbox: false
        });
    });
});

const wdgtPOIFilter = document.querySelectorAll('.wdgt-Poi .categoryFilter');

window.fireOnVisible(wdgtPOIFilter, async() => {
    await import('../../assets/frontend/styles/ck24_categoryFilter.scss');
    await import('./assets/js/PoiFilter.class.ts').then(function({ PoiFilterClass }) {
        new PoiFilterClass();
    });
});
